/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DnssecKeyReadDetails } from "../../models/dnssec-key-read-details";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetDomainDnssecKeys$Params {
  organisation_id: string;
  domain_id: string;
}

export function getDomainDnssecKeys(
  http: HttpClient,
  rootUrl: string,
  params: GetDomainDnssecKeys$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<DnssecKeyReadDetails>>> {
  const rb = new RequestBuilder(rootUrl, getDomainDnssecKeys.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("domain_id", params.domain_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DnssecKeyReadDetails>>;
    }),
  );
}

getDomainDnssecKeys.PATH = "/surfdomeinen/organisations/{organisation_id}/dnssec/domains/{domain_id}";
